import {
    Alert,
    Grid2
} from '@mui/material';
import { useState } from 'react';

import { ActualAuctionStatusEnum } from '../../../_common/enum/actualAuctionStatus';
import { accountService } from '../../../_services/accounts.service';
import { AuctionPostbackStatusEnum } from '../../../_common/enum/auctionPostbackStatus.enum';
import { CatalogueItemUserBidStatusEnum } from '../../../_common/enum/catalogueItemUserBidStatusEnum';


export function CatalogueItemStatusCard(params: { catalogueItem?: any, actualAuctionStatusId?: ActualAuctionStatusEnum }) {

    const [loading, setLoading] = useState(true);

    const reofferedToMe =
        params.catalogueItem?.catalogueItemBid?.catalogueItemUserBidStatusId === CatalogueItemUserBidStatusEnum.ReOffered ||
        params.catalogueItem?.auctionPostbackStatusId === AuctionPostbackStatusEnum.ReOffered;
    const sx = {
        fontSize: 24,
        '& .MuiAlert-icon': {
            fontSize: 36, // size for the icon container
            '& .MuiSvgIcon-root': { fontSize: 'inherit' } // make SVG follow it
        }
    }
    return (
        <Grid2 size={{ xs: 12 }}>
            {(params.actualAuctionStatusId === ActualAuctionStatusEnum.NotStarted) ? <><Alert sx={sx} elevation={1} severity="warning" >Auction is <strong>Pending</strong>. Please wait</Alert></> :
                (params.actualAuctionStatusId === ActualAuctionStatusEnum.NotRegistered) ? <Alert sx={sx} elevation={1} severity="error" > You are not registered for the current catalogue</Alert> :
                    (params.actualAuctionStatusId === ActualAuctionStatusEnum.Active) ? <Alert sx={sx} elevation={1} severity="success" > {accountService.isCustomer ? <>Bidding is Open</> : <>Catalogue Item Auction is <strong>Active</strong></>}</Alert> :
                        (params.actualAuctionStatusId === ActualAuctionStatusEnum.Paused) ? <Alert sx={sx} elevation={1} severity="warning" >Catalogue Item Auction has been <strong>Paused</strong> </Alert> :
                            (params.actualAuctionStatusId === ActualAuctionStatusEnum.BidAcceptance) ? <Alert sx={sx} elevation={1} severity="info" >Catalogue Item Auction bids have been submitted. <strong>Pending approval.</strong></Alert> :
                                (params.actualAuctionStatusId === ActualAuctionStatusEnum.ReOffered) ? (
                                    accountService.isAdminOrMonitorOrAuctioneer && !accountService.isProxyBidder
                                        ? <Alert sx={sx} elevation={1} severity="info" >Catalogue Item Auction has been <strong>ReOffered</strong></Alert>
                                        : reofferedToMe
                                            ? <Alert sx={sx} elevation={1} severity="info" ><strong>Tied Bid</strong> - please place another bid</Alert>
                                            : <Alert sx={sx} elevation={1} severity="warning" >Auction <strong>Pending</strong></Alert>
                                ) :
                                    params.actualAuctionStatusId === ActualAuctionStatusEnum.Completed ? <Alert sx={sx} elevation={1} severity="info" >Auction has been <strong>Completed</strong></Alert> :
                                        params.actualAuctionStatusId === ActualAuctionStatusEnum.UserDisconnected ? <Alert sx={sx} elevation={1} severity="warning" >Auction paused — a registered bidder is <strong>offline or away</strong></Alert> :
                                            params.actualAuctionStatusId === ActualAuctionStatusEnum.Pending ? <Alert sx={sx} elevation={1} severity="warning" >Catalogue item is <strong>Pending</strong></Alert> :
                                                params.actualAuctionStatusId === ActualAuctionStatusEnum.ClosingShortly ? <Alert sx={sx} elevation={1} severity="error" >Bidding is closing shortly!</Alert> :
                                                    <><Alert sx={sx} elevation={1} severity="warning" >Auction is <strong>Pending</strong>. Please wait</Alert></>
            }
        </Grid2 >
    )
}
